// The living design system: every token and component rendered from the real
// source, so it cannot drift the way a hand-written document would.
//
// It is a reference, not a marketing page, so it carries no SEO metadata and
// no i18n namespace of its own.
export default [
  {
    path: '/design-system',
    // The i18n router hook loads `locales/{lang}/{route.name}.json`, so a
    // route's name doubles as its translation namespace. `common` is the right
    // namespace here — the page renders real components that call $t() —
    // and it avoids the "no translation file found" error a bespoke name logs.
    name: 'common',
    component: () => import('@/views/design-system/DesignSystemPage.vue'),
  },
]
